module.exports = __webpack_public_path__ + "img/failed.eba99827.png";